import {
  BtnLanguage,
  CaptionHide,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyList,
  PolicySectionTitle,
  PolicyTable,
  PolicyText,
  PolicyTitle,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const JaPrivacy = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "ja";
    document.title = "40weeks later";
    return () => {
      document.documentElement.lang = "ko";
      document.title = "열달후에";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">40weeks later</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          EN
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/privacy">EN</Link>
            </li>
            <li className="selected">
              <em>JP</em>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>
      <PolicyTitle>「40weeks later」プライバシーポリシー</PolicyTitle>

      <PolicySectionTitle id="privacy01">1. はじめに</PolicySectionTitle>
      <PolicyText>
        株式会社コネクトアイ(以下「当社」といいます。)は情報主体の個人情報保護を非常に重要視し、情報主体が会社の「十ヶ月後」サービス(以下「サービス」といいます。)を利用するとともにオンライン上で会社に提供した個人情報が保護されるよう最善を尽くしています。当社は、当社が事業を行う国または地域において適用される法令および規制(これらの法令および規制を併せて以下、「適用法」といいます。)を遵守し、本プライバシーポリシーに基づいて適切に個人情報を保護していくことに努めてまいります。
      </PolicyText>
      <PolicyText>
        当社は本プライバシーポリシーを通じて情報主体が提供する個人情報がどのような用途と方式で利用されており、個人情報保護のためにどのような措置が取られているのかをお知らせします。また、本プライバシーポリシーをサービス内に公開することにより、情報主体が常に容易に見られるように措置しています。
      </PolicyText>

      <PolicySectionTitle id="privacy02">
        2. 本ポリシーの適用範囲
      </PolicySectionTitle>
      <PolicyText>
        本ポリシーは、国や地域を問わず、当社サービスに関連して取得されるすべてのパーソナルデータに適用されます。
      </PolicyText>
      <PolicyText>
        当社は、適用法により許容される限りにおいて、本ポリシーに従い、かつ本ポリシーに記載された範囲に限り、パーソナルデータを取り扱います。
      </PolicyText>
      <PolicyText>
        なお、当社は複数の言語で本ポリシーを提供する場合がありますが、適用法の下で許可されている範囲で日本の利用者は日本語版が適用されます。
      </PolicyText>

      <PolicySectionTitle id="privacy03">
        3. 取得する個人情報の項目及び収集方法等
      </PolicySectionTitle>
      <PolicyArticleTitle>3.1. 取得する個人情報項目</PolicyArticleTitle>
      <PolicyText>
        当社は、本サービスの提供にあたり、本サービスの利用者から、以下の情報を、以下の方法により取得します。
      </PolicyText>
      <PolicyList>
        <li>
          ①
          会員登録時に取得される情報は、会員登録意思確認、識別及び認証、会員資格維持及び管理、本人確認、サービス不正利用確認及び防止、各種告知及び通知のために取得します。
          <PolicyHyphenList>
            <li>メールアドレス</li>
            <li>生年月日</li>
            <li>ニックネーム、写真(コミュニティ利用時)</li>
            <li>居住国のローカルタイムおよび言語</li>
          </PolicyHyphenList>
        </li>
        <li>
          ②
          サービス利用時に取得される情報は、当該サービスを提供するために収集される情報であり、当該サービスの利用及びデータ保存時にのみ収集されます。保存したデータを利用者が削除する場合は、会員退会の有無にかかわらず取得されたデータも直ちに削除されます。
          <PolicyTable>
            <CaptionHide>サービス,取得する個人情報,利用目的</CaptionHide>
            <colgroup>
              <col style={{ width: "20% " }} />
              <col style={{ width: "40% " }} />
              <col style={{ width: "40% " }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">サービス</th>
                <th scope="col">取得する個人情報</th>
                <th scope="col">利用目的</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>妊娠準備 モード</td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>
                      生理周期、最後の生理日、生理開始日、生理終了日、排卵日
                    </li>
                    <li>排卵検査日時、排卵検査薬の撮影写真、排卵検査結果</li>
                    <li>妊娠検査日時、妊娠検査薬の撮影写真、妊娠検査結果</li>
                    <li>不妊治療の日程履歴(出産治療モード選択時)</li>
                    <li>その他の生理周期,妊娠,健康に関するさまざまな症状</li>
                  </PolicyHyphenList>
                </td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>
                      生理予定日、妊娠期、排卵予定日予測および生理周期別オーダーメード型コンテンツ提供
                    </li>
                    <li>排卵テスト自動結果判読</li>
                    <li>妊娠テストの結果記録および10ヶ月ママトーク共有</li>
                    <li>
                      不妊治療のスケジュール管理及び薬物/注射投薬のお知らせ
                    </li>
                  </PolicyHyphenList>
                </td>
              </tr>
              <tr>
                <td>妊娠 モード</td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>妊娠週数日</li>
                    <li>胎児の超音波写真(胎児測定値を含む)</li>
                    <li>妊娠前の身長、体重</li>
                    <li>体重記録ヒストリー</li>
                  </PolicyHyphenList>
                </td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>
                      ダイアリーの記録及び出産予定日D-day、妊娠週数別コンテンツ提供
                    </li>
                    <li>
                      週数別/日別パーセンタイル計算による胎児成長報告書の提供
                    </li>
                    <li>
                      週数別体重増加量、増加率、BMI計算およびパーセンタイル計算による産婦体重報告書の提供
                    </li>
                  </PolicyHyphenList>
                </td>
              </tr>
              <tr>
                <td>育児 モード</td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>子供の名前、性別、生年月日</li>
                    <li>子供の出生時の体重、身長、頭囲</li>
                    <li>子供の身体測定値</li>
                    <li>月齢別発達チェック項目別記録、項目別点数、写真</li>
                    <li>会員様の妊娠前体重,身長、出産直前の駐車体重</li>
                    <li>体重記録ヒストリー</li>
                  </PolicyHyphenList>
                </td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>子供の月齢別コンテンツ提供</li>
                    <li>パーセンタイル計算および子供成長報告書提供</li>
                    <li>月齢別発達チェックミッション及び結果報告書提供</li>
                    <li>出産後の体重管理サービスの提供</li>
                  </PolicyHyphenList>
                </td>
              </tr>
              <tr>
                <td>ママトーク</td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>プロフィール画像</li>
                    <li>氏名(ニックネーム)</li>
                  </PolicyHyphenList>
                </td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>イベント参加時、本人識別</li>
                    <li>
                      投稿文の壁紙、広告文の作成など運営原則に反する不正利用の確認及び防止
                    </li>
                  </PolicyHyphenList>
                </td>
              </tr>
              <tr>
                <td>マイメニュー</td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>プロフィール画像</li>
                    <li>氏名(ニックネーム)</li>
                  </PolicyHyphenList>
                </td>
                <td className="cell_left">
                  <PolicyHyphenList>
                    <li>サービス利用時の実名代替</li>
                  </PolicyHyphenList>
                </td>
              </tr>
            </tbody>
          </PolicyTable>
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        3.2. 取得した個人情報の保有及び利用期間
      </PolicyArticleTitle>
      <PolicyText>
        当社は会員登録時に保存された個人情報は利用者の会員脱退時に直ちに削除します。但し、サービス利用中に利用者の記録及び保存により収集された情報は、本サービスの提供終了後も、個人を識別できない形式に加工して保持します。当該情報を利用する必要がなくなったときは、当該情報を遅滞なく消去するよう努めます。
      </PolicyText>

      <PolicySectionTitle id="privacy04">
        4. 個人情報の利用目的
      </PolicySectionTitle>
      <PolicyText>
        当社は、利用者にサービスを提供したり、安心でより良いサービスを提供するための研究・開発に役立てたり、広告も含めより利用者に関連性の強いサービスを提供するために個人情報を利用します。取得した個人情報は、利用者から同意を得た範囲または適用法で認められる場合を除き、利用の目的の範囲を越えて取り扱いません。
      </PolicyText>
      <PolicyText>
        当社は個人情報の主体である個人(以下「利用者」といいます。)の事前同意なしには利用者の個人情報を公開せず、個人情報を以下の目的で利用いたします。
      </PolicyText>
      <PolicyList>
        <li>
          ①
          当社が提供するサービス(以下「本サービス」といいます。)の会員登録意思確認、利用者識別、会員退会意思確認など会員管理のために活用
        </li>
        <li>
          ②
          本サービス(当社が協賛企業各社と共同して提供するキャンペーンを含みます。)の提供
        </li>
        <li>
          ③
          利用者の同意に基づき、個人情報を協賛企業各社及び広告プラットフォームを運営する企業に提供するため
        </li>
        <li>
          ④
          利用者と約束したサービス提供、サービス提供に伴う本人認証、問い合わせまたは苦情処理および返信、お知らせ伝達に活用
        </li>
        <li>
          ⑤
          法令及び利用約款に違反する会員に対する利用制限措置、不正利用行為を含めサービスの円滑な運営に支障をきたす行為、非認可行為に対する防止及び制裁、アカウント盗用防止、紛争調整のための記録保存など利用者保護及び安全なサービス運営に活用
        </li>
        <li>⑥ 本サービスに関する規約等の変更などを通知するため</li>
        <li>
          ⑦
          本サービス利用性向、関心、利用記録分析などを反映した新規サービス開発およびオーダーメード型サービス提供などサービス改善に活用
        </li>
        <li>
          ⑧
          イベント情報や参加機会の提供、広告性情報の提供など、マーケティングやプロモーションに活用
        </li>
        <li>
          ⑨
          本サービスに関連して、個人を識別できない形式に加工した統計データを作成するため
        </li>
        <li>⑩ その他、上記利用目的に付随する目的のため</li>
      </PolicyList>

      <PolicySectionTitle id="privacy05">5. 個人情報の提供</PolicySectionTitle>
      <PolicyText>
        当社は、利用者から同意を得た場合または適用法で認められる場合を除き、原則として、個人情報を第三者に提供することはありません。
      </PolicyText>
      <PolicyText>
        ただし、以下のような場合には、当社は、個人情報を第三者に提供することがあります。
      </PolicyText>
      <PolicyText>
        当社の個人情報の提供先には、利用者のお住まいの国以外の国または地域にある委託先、子会社、関連会社などの第三者を含みます。
      </PolicyText>
      <PolicyText>
        当社は、日本と同等の個人データ保護法制を持つ国若しくは地域(欧州経済領域や欧州委員会が十分な保護水準を確保していると認定している国や地域など)又はAPECによる越境個人情報保護に係る枠組み(CBPRシステム)の加盟国にデータセンターの拠点を有しております。
      </PolicyText>
      <PolicyList>
        <li>
          ① 業務委託
          <br />
          当社はサービス向上のために情報主体の個人情報を外部専門業者に委託して処理することができます。これらの業務委託先は、当社に代わって業務を遂行するために必要最低限の個人情報にのみアクセスし、委託業務の範囲を超えて個人情報を利用することはありません。
          <br />
          委託業務の内容や受託者が変更される場合には、遅滞なく本プライバシーポリシーを通じて公開するようにします。
          <br />
          <br />
          <PolicyTable>
            <caption>[委託業者及び委託業務]</caption>
            <colgroup>
              <col style={{ width: "20% " }} />
              <col style={{ width: "40% " }} />
              <col style={{ width: "40% " }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">国</th>
                <th scope="col">委託業者</th>
                <th scope="col">委託業務内容</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>韓国</td>
                <td>NHN Cloud (NHN Cloud, Inc. Republic of Korea)</td>
                <td>電子メールの送信</td>
              </tr>
              <tr>
                <td>韓国</td>
                <td>AWS (Amazon Web Services, Inc.)</td>
                <td>データ保管</td>
              </tr>
            </tbody>
          </PolicyTable>
        </li>
        <li>
          ② コンプライアンスおよび公的機関への協力
          <br />
          当社は、令状などの法的手続きに則った要請を受領した場合や、自殺予告や爆破予告など身体または財産に危難が差し迫っている場合など、適用法に基づいて警察などの法執行機関や裁判所などの第三者に対してパーソナルデータを開示することがあります。
        </li>
      </PolicyList>
      <PolicySectionTitle id="privacy06">
        6. 個人情報の安全管理
      </PolicySectionTitle>
      <PolicyText>
        当社は、利用者の個人情報を取り扱うにあたり、個人情報が紛失、盗難、漏洩、変造、または毀損されないよう、安全性確保のために、次のような技術的/管理的対策を講じています。
      </PolicyText>
      <PolicyList>
        <li>
          (1) 技術的対策
          <ul>
            <li>
              ①
              利用者の個人情報は暗号アルゴリズムを利用して安全に保護·保存されており、ネットワーク上の伝送データを暗号化したりファイルロック機能(Lock)を使用して重要なデータは別途のセキュリティ機能を通じて保護されています。
            </li>
            <li>
              ②
              会社はワクチンプログラムを利用してコンピュータウイルスの被害を防止しています。ワクチンプログラムは周期的にアップデートされ、ウイルスが突然出現した時にはワクチンが出てすぐに提供することで個人情報が侵害されることを防止しています。
            </li>
            <li>
              ③
              会社はハッキングなど外部侵入に備えて、サーバーごとに侵入遮断システムおよび脆弱性分析システムなどを利用してセキュリティに万全を期しています。
            </li>
          </ul>
        </li>
        <li>
          (2) 管理的対策
          <ul>
            <li>
              ①
              当社は個人情報の安全な保護のために外部専門機関から情報保護管理体系などに対する客観的な認証を受け、主要システムと設備を運営しています。
            </li>
            <li>
              ②
              当社は利用者の個人情報に対するアクセスと管理に必要な手続きなどを設け、所属職員にこれを熟知して遵守するようにしており、個人情報を取り扱う職員を対象に新しいセキュリティ技術習得および個人情報保護義務などに関する定期的な社内教育を施行しています。
            </li>
            <li>
              ③
              当社は利用者の個人情報へのアクセス権限を最小限の人数に制限しています。
            </li>
            <li>
              ④
              個人情報関連取扱者の業務引継ぎはセキュリティが維持された状態で徹底的に行われており、入社および退社後の個人情報事故に対する責任を明確にしています。
            </li>
            <li>
              ⑤
              当社がコンピュータを利用して顧客の個人情報を処理する際には、個人情報に対するアクセス権限がある担当者を指定して識別符号(ID)とパスワード(PASSWORD)を付与し、当該パスワード(PASSWORD)を定期的に更新しています。
            </li>
            <li>
              ⑥
              当社は新規職員を採用する際、情報保護誓約書または個人情報保護誓約書に署名させ、職員による情報流出を事前に防止しており、個人情報処理方針に対する履行事項と職員遵守可否を監査するための内部手続きを用意し持続的に施行しています。
            </li>
            <li>
              ⑦
              当社は、従業員が退職する際に秘密保持誓約書に署名させることで、顧客の個人情報を扱っていた者が職務上知り得た個人情報を毀損、侵害、または漏洩しないようにしています。
            </li>
            <li>
              ⑧
              サービス利用契約締結、サービス提供などのために顧客のクレジットカード番号、銀行決済口座など代金決済に関する情報を収集したり顧客に提供する際、会社は該当顧客が本人であることを確認するよう措置しています。
            </li>
          </ul>
        </li>
      </PolicyList>
      <PolicyArticleTitle>6.2. 個人情報の保管場所</PolicyArticleTitle>
      <PolicyText>
        当社は日本の利用者の個人情報を韓国のデータセンターで保管しています。
      </PolicyText>
      <PolicyText>
        なお、日本および韓国はAPECによる越境個人情報保護に係る枠組み(CBPRシステム)に参加し、欧州委員会による十分性認定を受けております。
      </PolicyText>
      <PolicyArticleTitle>6.3. 個人情報の保存期間</PolicyArticleTitle>
      <PolicyText>
        当社は、利用者の要請に沿ったサービスを提供し、本ポリシーに記載されている利用目的を達成するため、または適用法を遵守するために、個人情報を取得・保存します。
      </PolicyText>
      <PolicyText>
        利用者がアカウントの削除(会員脱退)を申請しない限り、当社は原則として利用者の個人情報の大部分を保持します。アカウントが削除された場合には、以下の事項のために一定期間保持した後、適用法および社内規程に従って適切に個人情報を取り扱います。
      </PolicyText>
      <PolicyHyphenList>
        <li>問合せ対応</li>
        <li>紛争解決および料金徴収</li>
        <li>不正の検知および対策</li>
        <li>適用法または金融商品取引所の定める規則上の義務</li>
      </PolicyHyphenList>
      <PolicyText>
        その他、当社は以下のような基準に沿ってパーソナルデータの保存期間を定めています。
      </PolicyText>
      <PolicyHyphenList>
        <li>
          キャンペーンで取得した商品の発送のために得た配送先情報は、配送が完了した後、紛争解決のために一定期間保持した後に削除されます。このように限定した目的のために取得した情報は、その目的達成後、合理的な期間を経過した後に速やかに削除されます。
        </li>
      </PolicyHyphenList>
      <PolicyText>
        適用法などに保存期間の定めがある場合、当社はこれに従い個人情報を保存します。
      </PolicyText>
      <PolicyText>
        なお、当社は、適用法および社内規定に従って定めた保存期間経過後、個人情報を個人を特定できない形で保有する場合があります。
      </PolicyText>

      <PolicySectionTitle id="privacy07">
        7. 個人情報に対する利用者の選択肢
      </PolicySectionTitle>
      <PolicyText>
        利用者は、当社に対して適用法において認められる限りにおいて、ご自身の個人情報にアクセスする権利や個人情報を訂正する権利など、当社が取り扱う利用者の個人情報に係る権利を有しています。
      </PolicyText>
      <PolicyText>
        当社は、利用者ご自身が、プロフィール編集、個人情報の取得・使用・共有に関する設定・管理を行うことができる機能を当社サービス上で提供するよう努めています。
      </PolicyText>
      <PolicyText>
        利用者は、当社が取り扱う利用者の個人情報について、適用法において認められる限りにおいて、アクセスする権利、訂正を求める権利、消去を求める権利、取扱いを制限する権利、同意を撤回する権利、データポータビリティの権利、データ処理の存在を確認する権利、データ処理に基づく自動的な決定のレビューを要求する権利などを有します。
      </PolicyText>
      <PolicyText>
        また利用者は、適用法において認められる限りにおいて、一定の場合に当社による利用者の個人情報の取扱いに異議を申し立てる権利を有します。
      </PolicyText>
      <PolicyText>
        当社は、個人情報をアプリ上から利用者ご自身で管理することができるよう、プロフィール編集、取得・使用・共有に関する設定、広告のオプトアウト、アカウント削除などの個人情報の設定・管理に係る機能を当社サービス上で提供するよう努めています。古い情報や不正確な情報が残っていないか定期的にご確認頂き、適切に更新してください。
      </PolicyText>
      <PolicyText>
        利用者が、当社に対し、当社サービス上で確認できない個人情報の開示や事実でない個人情報の訂正・削除、利用目的の通知、その他適用法で認められる権利の行使を求める場合には、カスタマーセンターの「1:1お問い合わせ」からご連絡ください。
      </PolicyText>
      <PolicyText>
        利用者の身元を検証した後、合理的な期間内に関連する法律に従って利用者の要求に応答します。ただし、適用法で認められる限りにおいて、以下に該当する場合は、当社は利用者の請求に応じることができない場合があります。
      </PolicyText>

      <PolicyHyphenList>
        <li>
          開示することで生命、身体、財産その他の権利利益を害するおそれがある場合
        </li>
        <li>
          開示することで当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
        </li>
        <li>開示することが法令に違反することとなる場合</li>
        <li>開示の請求がご本人からであることが確認できない場合</li>
        <li>
          その他、適用法上、請求に応じることを当社が拒否することが認められる場
        </li>
      </PolicyHyphenList>

      <PolicyText>
        もし利用者が当社サービスを使用することをこれ以上望まない場合、あるいは当社が当社サービスを提供するにあたり必要な個人情報の取扱いについて同意を撤回する場合、利用者は会員退会を通じてアカウント全体を削除することを選択することができます。ただし、同意の撤回は、撤回前の同意に基づく当社による取扱いの適法性に影響を与えません。
      </PolicyText>
      <PolicyText>
        また、個人情報の利用に関する要望や苦情に関しては、いつでもカスタマーセンターの「1:1お問い合わせ」からお問い合わせください。
      </PolicyText>
      <PolicyText>
        なお、適用法において認められない場合を除き、当社が別途定めた手続きに従って手数料をいただく場合があります。
      </PolicyText>

      <PolicySectionTitle id="privacy08">
        8. 他社モジュール、Cookieなどの利用について
      </PolicySectionTitle>
      <PolicyText>
        当社は、本ポリシーに記載した目的のために、Cookieおよび他社が提供するSDKなどを利用することがあります。
      </PolicyText>

      <PolicyList>
        <li>
          ① 他社モジュール
          <br />
          当社は、当社サービスの利用状況を分析し、又は当社に代わって広告を配信し、又はその効果を測定するため、他社が提供するソフトウェア・デベロップメント・キット(SDK)などのモジュールを当社サービス内に設置する場合があります。
          <br />
          他社が提供するモジュールを通じて、他社が取り扱うパーソナルデータについては、当該他社のプライバシーポリシーが適用されます。このような他社モジュールに関する詳細は、マイメニュー内のカスタマーセンターの「オープンソースライセンス」から確認することができます。
        </li>
        <li>
          ② Cookieその他の解析ツール
          <br />
          Cookieとは、ウェブサイトを訪問するとき、利用者のコンピュータに保存される小さなテキストファイルです。このテキストファイルは、後日再びそのウェブサイトを訪問した際にサイト運営者が読むことができるような情報を格納保存します。当社は、以下のような目的でCookieを使用する場合があります。
          <PolicyHyphenList>
            <li>
              ログイン状態を記憶し、訪問者の認証やセッションの維持、セキュリティ対策に利用するため
            </li>
            <li>
              言語などの設定内容や最終訪問日時などを記憶しておき、利便性を向上するため
            </li>
            <li>
              訪問回数や利用形態などを把握することにより、より良いサービスを提供するため
            </li>
            <li>より関心の強い広告を配信するため</li>
          </PolicyHyphenList>
          ブラウザの設定やその他のツールを用いて、Cookieを受け入れるかどうかを制御することができます。しかし、利用者がもしCookieを無効化するか、Cookieを設定する機能を制限する場合は、ウェブサイトの全部または一部の機能にアクセスできなくなり、その結果として利用者の全体的な利便性を制限する可能性があります。
        </li>
        <li>
          ③ Google Analyticsの利用に関する情報
          <br />
          当社は、当社サービスの向上のため、Google社のGoogle
          Analyticsを利用してウェブサイトなどの当社サービスの計測を行っています。データ取得のためにGoogle社がCookieを設定し、または既存のCookieを読み取る場合があります。その際、Google社に対して、利用者がアクセスしたページのURLやIPアドレスなどの情報を自動的に送信します。当社は、それらの情報を、利用状況の把握や当社サービスなどに利用する場合があります。Google
          AnalyticsにおけるGoogle社によるデータの取扱いについては、Google
          Analyticsサービス利用規約およびGoogle社プライバシーポリシーをご確認ください。
        </li>
      </PolicyList>

      <PolicySectionTitle id="privacy09">
        9. その他の重要な情報
      </PolicySectionTitle>
      <PolicyText>
        本ポリシーは改定することがあります。ご覧のサイトまたはアプリ内で常に最新のプライバシーポリシーを掲載しておりますので、利用者に適用される最新のプライバシーポリシーの内容を十分にご確認ください。
      </PolicyText>
      <PolicyText>
        重要な変更にあたっては、利用者に対してわかりやすい方法にて改定内容を告知いたします。
      </PolicyText>
      <PolicyList>
        <li>
          ① 問合せ先
          <br />
          他に言及されている場合を除き、当社が、本ポリシーの対象サービスを通じて取得した個人情報のデータ管理者となります。本ポリシーに関してご不明な点のお問い合わせや、サービスにおける個人情報の取り扱いに関するご質問・苦情・ご相談・コメントなどは、カスタマーセンターの「1:1お問い合わせ」からご連絡いただくか、以下窓口まで郵便でご連絡ください。
          <br />
          {/* 주소 변경시 우편번호도 같이 수정 해야함 */}
          〒04051
          <br />
          #56, B2, 176 Yanghwa-ro, Mapo-gu, Seoul, South Korea
          <br />
          株式会社コネクトアイ(Connect i Co.,Ltd.)
          <br />
          パーソナルデータの取扱いに関する責任者 : プライバシーオフィサー
          <br />
          E-mail : after10month@connect-i.co.kr
        </li>
        <li>
          ② プライバシーポリシーの変更
          <br />
          本ポリシーは随時改定されることがあり、ご覧のサイトまたはアプリ内で常に最新のプライバシーポリシーを掲示しております。重要な変更にあたっては、サービス内での通知などを通じて利用者に対してわかりやすい方法にて改定内容を告知いたします。最新のプライバシーポリシーの内容を十分にご確認ください。
          <br />
          もし利用者が変更内容に同意せず、私たちのサービスをこれ以上使用することを望まない場合、利用者はアカウントを閉鎖することができます。変更が通知された後、あるいはサービス上に公表された後に私たちのサービスを使用し続けることは、変更の受諾と修正された本ポリシーへの同意を構成します。なお、適用法で求められる場合は、利用者に同意を求めます。
        </li>
      </PolicyList>

      <PolicyText>株式会社コネクトアイ(Connect i Co.,Ltd.)</PolicyText>
      <PolicyText>代表取締役 CEO SangJik Ryu</PolicyText>
      <PolicyText>2023年 10月 20日 制定</PolicyText>
    </PolicyContainer>
  );
};

export default JaPrivacy;
